<template>
    <div id="invitation">
        <img class="top-back" src="@/assets/invite-new/top-back.png"/>
        <img class="top-logo" src="@/assets/invite-new/logo.png" alt="">
        <h1 class="slogn s1" :class="$i18n.locale" >{{$t('invite.invite_friend')}}</h1>
        <h1 class="slogn s2" :class="$i18n.locale">{{$t('invite.get_bot')}}</h1>
        <div class="code-back">
            <div class="qr-code-box" ref="qrCodeUrl"></div>
            <div class="mb-6">{{ $t('invite.scan_down') }}</div>
            <div class="text-box">
                <img class="icon" src="@/assets/invite-new/icon1.png" alt="">
                <span class="content">{{ $t('invite.invite_code') }}：{{ inviteInfo.inviteCode }}</span>
                <span class="copy-btn copy-btn-code" @click="copyCode">
                    <img src="@/assets/invite-new/copy.png" alt="">
                </span>
            </div>
            <div class="text-box">
                <img class="icon" src="@/assets/invite-new/icon2.png" alt="">
                <span class="content">{{ (myWindow.location.protocol + "//" + myWindow.location.host).substr(0, 20) }}...{{ inviteInfo.inviteCode }}</span>
                <span class="copy-btn copy-btn-url" @click="copyUrl">
                    <img src="@/assets/invite-new/copy.png" alt="">
                </span>
            </div>
            <div id="invite-button" class="invite-button" @click="goInvite">{{ $t('invite.invite') }}</div>
        </div>
        <img class="bit-img" src="@/assets/invite-new/bit.png" alt="">
        
        <jgz-loading :loading-show='showLoading'></jgz-loading>
        <div class="alert" v-show="alertShow">
            <span>{{ message }}</span>
        </div>
        <div v-show="isiOS" class="ios-warn">{{ $t('invite.not_apple') }}</div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import JgzLoading from '@/components/JgzLoading.vue'
import Clipboard from 'clipboard'
export default {
    name: 'Invitation',
    components: {
        JgzLoading,
    },
    data() {
        return {
            isiOS: false,
            username: '',
            inviteInfo: {},

            message: '',
            alertShow: false,
            showLoading: false,
            myWindow: window,
            language: '',
        }
    },
    mounted() {
        const u = navigator.userAgent;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        this.username = this.$route.query.username ? this.$route.query.username : 123456;
        this.language = this.$route.query.language
        let token = this.$route.query.auth;
        // debugger
        token = decodeURI(token)
        this.$MyAxios.axiosInstance.defaults.headers.common['Authorization'] = token;

        this.showLoading = true;
        this.getUserData();
    },
    methods: {
        getUserData() {
            this.$MyAxios.get('/api/user/invites/search/findByUsername', {
                params: {
                    username: this.username,
                }
            }, response => {
                if(response.code == 1) {
                    this.inviteInfo = response.data;
                    this.showLoading = false;

                    // 添加监听事件
                    var btn = document.getElementById("invite-button"); 
                    btn.addEventListener("click", function () { 
                        //  安卓
                        // debugger
                        if (window.goInvite) {  
                            let str = JSON.stringify(response.data);
                            goInvite.setValue(str);
                        }
                        
                    });
                    this.creatQrCode()
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
                this.creatQrCode()
            })
        },
        
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },

        copyCode(code) {
            // return
            // //  ios复制
            // this.setupWebViewJavascriptBridge(function(bridge) {
			// 	bridge.callHandler('copyCode', code);
            // }); 

            // //  安卓复制
            // if (window.androidListener) {
            //     androidListener.copyCode(code);
            // }

            // this.showAlert('复制成功')
            let str = this.inviteInfo.inviteCode 
            let clipboard = new Clipboard('.copy-btn-code', {
                text: function () {
                    return str
                }
            })
            clipboard.on('success', e => {
                this.showAlert(this.$t('down.copy_success'))
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert(this.$t('down.copy_failed'))
                clipboard.destroy()
            })
            
        },

        copyUrl() {
            let str = `${window.location.protocol}//${window.location.host}/sign-in/?language=${this.language}&inviteCode=${this.inviteInfo.inviteCode}`
            let clipboard = new Clipboard('.copy-btn-url', {
                text: function () {
                    return str
                }
            })
            clipboard.on('success', e => {
                this.showAlert(this.$t('down.copy_success'))
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert(this.$t('down.copy_failed'))
                clipboard.destroy()
            })
            
        },
        
        creatQrCode() {
            let str = window.location.protocol + "//" + window.location.host + '/sign-in/?inviteCode=' + this.inviteInfo.inviteCode 
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: str, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            // new QRCode(this.$refs.qrCodeUrl, this.codeUrl);
        },

        goInvite() {
            let data = this.inviteInfo;
            //  ios
            this.setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('goInvite', {data: data});
            }); 
            console.log('postMessage')
            window.parent.postMessage({
                method: "goInvite",
                data: data
            },'*');
        },
        
        iosShowLoading() {
            this.setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('showLoading', {data: data});
            }); 
        },
        
        iosHideLoading() {
            this.setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('showLoading', {data: data});
            });
        },
        setupWebViewJavascriptBridge(callback) {
            if (window.WebViewJavascriptBridge) {
                return callback(WebViewJavascriptBridge);
            }
            if (window.WVJBCallbacks) {
                return window.WVJBCallbacks.push(callback);
            }
            window.WVJBCallbacks = [callback];
            var WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
            document.documentElement.appendChild(WVJBIframe);
            setTimeout(function () {
                document.documentElement.removeChild(WVJBIframe)
            }, 0)
        }
    }
}
</script>

<style lang='less'>
#invitation {
    // background-image: url(../assets/Invitation/background.png);
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    background-color: #FFEED4;
    width: 100%;
    min-height: 100vh;
    position: relative;
    img {
        pointer-events: none;
    }
    .top-back {
        position: absolute;
        top: 0px;
        left: 0px;
        height: 560px;
        width: 100vw;
    }
    .top-logo {
        width: 282px;
        height: 45px;
        left: 40px;
        top: 40px;
        position: absolute;
    }
    .slogn {
        position: absolute;
        top: 140px;
        left: 0;
        width: 100%;
        text-align: center;
        height: 90px;
        color: #FFFFFF;
        font-size: 64px;
        font-weight: 600;
        font-family: PingFang SC, PingFang SC-Semibold;
        letter-spacing: 10px;
        z-index: 2;
        &.en {
            letter-spacing: 0px;
        }
    }
    .s2 {
        top: 230px;
    }
    .bit-img {
        position: absolute;
        top: 268px;
        left: 525px;
        height: 205px;
        width: 202px;
    }
    .code-back {
        position: absolute;
        background-image: url(../assets/invite-new/code-back.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        left: 25px;
        top: 390px;
        height: 610px;
        width: 700px;
        padding-top: 70px;
        .code {
            width: 200px;
            height: 200px;
            margin-bottom: 20px;
            background-color: #F2F3F5;
        }
        .qr-code-box {
            height: 200px;
            width: 200px;
            margin: 0 auto 20px auto;
            canvas {
                height: 200px !important;
                width: 200px !important;
            }
            img {
                height: 200px !important;
                width: 200px !important;
            }
        }
        .mb-6 {
            margin-bottom: 60px;
            color: #000000;
            font-size: 28px;
            line-height: 40px;
            font-weight: bold;
        }
    }
    .text-box {
        height: 48px;
        width: 540px;
        margin: 0 auto 30px;
        text-align: left;
        .icon {
            width: 48px;
            height: 48px;
            margin-right: 15px;
        }
        .content {
            display: inline-block;
            margin-right: 27px;
            width: 400px;
            overflow: hidden;
        }
        .copy-btn {
            img {
                width: 40px;
                height: 40px;
            }
        }
        img, span {
            vertical-align: middle;
        }
    }
    .invite-button {
        position: absolute;
        background: linear-gradient(90deg,#ffa41f 0%, #ff5e03 100%);
        border-radius: 44px;
        width: 690px;
        height: 88px;
        top: 632px;
        left: 0;
        line-height: 88px;
        font-size: 32px;
        color: #ffffff;
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
    .ios-warn {
        position: absolute;
        width: 100vw;
        font-size: 20px;
        bottom: 30px;
        text-align: center;
        color: gray;
    }
}
</style>
